import { PermissionsEndpoints } from "../api/admin/permissions.endpoints";
import APIrequest from "../lib/axios";

export const PermissionsService = {
    async createPermission(data) {
        try {
            const payload = {
                ...PermissionsEndpoints.createPermission,
                bodyData: data,
            };
            const response = await APIrequest(payload);
            return response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    },
    async getAllPermissions() {
        try {
            const payload = {
                ...PermissionsEndpoints.getAllPermissions,
            };
            const response = await APIrequest(payload);
            return response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    },
    async getPermission(id) {
        try {
            const payload = {
                ...PermissionsEndpoints.getPermission(id),
            };
            const response = await APIrequest(payload);
            return response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    },
    async updatePermission(id, data) {
        try {
            const payload = {
                ...PermissionsEndpoints.updatePermission(id),
                bodyData: data,
            };
            const response = await APIrequest(payload);
            return response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    },
    async deletePermission(id) {
        try {
            const payload = {
                ...PermissionsEndpoints.deletePermission(id),
            };
            const response = await APIrequest(payload);
            return response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    },
};
